import lodash from 'lodash';

const removeEmptyValues = (object) => {
  // Create deep copy of object
  const objCopy = JSON.parse(JSON.stringify(object));

  const omitEmpty = (obj) => {
    for (let prop in obj) {
      // If property value is falsy, remove from object
      if (!obj[prop]) {
        delete obj[prop];
      }
      // If property value is nested object
      else if (typeof obj[prop] === 'object') {
        // Run through object recursively
        omitEmpty(obj[prop]);
        // If object is has no properties, remove from object
        if (Object.keys(obj[prop]).length === 0) {
          delete obj[prop];
        }
      }
    }
    return obj;
  };

  return omitEmpty(objCopy);
};

lodash.mixin({
  removeEmptyValues
});

export default lodash;
